module.exports = __webpack_public_path__ + "statics/img/google-relieve.3b82783d.png";